export const GET_PRODUCTS = 'GET_PRODUCTS'
export const ADD_PRODUCT = 'ADD_PRODUCT'
export const UPDATE_CART = 'UPDATE_CART'
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS'
export const CLEAR_CART = 'CLEAR_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
